module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-6fb2c20b9ccc99e564c343a5be5c2df6.png";